const useChangeClientPasswordDto = (
  options?: GraphqlMutationOptions<ChangeClientPasswordMutation, ChangeClientPasswordMutationVariables>,
) => {
  const mutation = useGraphqlMutation(ChangeClientPasswordSchema, options);

  return {
    ...mutation,
  };
};

export { useChangeClientPasswordDto };
